import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Header from './components/header/header';
import Player from './components/player/player';
import Footer from './components/footer/footer';
import MobileApp from './components/mobile/MobileApp';
import useMediaQuery from './hooks/useMediaQuery';
import './index.css';
import Store from './store';
import HttpsRedirect from 'react-https-redirect';
// vConsole removed - no longer needed for debugging

// Десктопная версия (текущий дизайн)
const DesktopApp = () => (
  <>
    <Header />
    <div className="container">
      <Player />
    </div>
    <Footer />
  </>
);

// Главный компонент с переключением версий
const AppContent = () => {
  const breakpoint = useMediaQuery();

  // --- AUTO-UPDATE LOGIC ---
  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Fetch version with cache-buster to get fresh server value
        const response = await fetch(`./version.json?t=${Date.now()}`);
        const data = await response.json();
        const serverVersion = data.version;
        const localVersion = localStorage.getItem('app_version');

        if (localVersion && serverVersion > parseInt(localVersion)) {
          console.log('[Updater] New version detected, reloading...');
          localStorage.setItem('app_version', serverVersion);
          // Hard reload to bypass browser cache
          window.location.reload(true);
        } else if (!localVersion) {
          localStorage.setItem('app_version', serverVersion);
        }
      } catch (err) {
        console.warn('[Updater] Failed to check for updates:', err);
      }
    };

    // Check on mount
    checkVersion();
    
    // Optional: Check every hour if left open
    const interval = setInterval(checkVersion, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // Mobile: ≤768px - Android app style
  // Tablet/Desktop: >768px - current design
  if (breakpoint === 'mobile') {
    return <MobileApp />;
  }

  return <DesktopApp />;
};

function App() {
  return (
    <HttpsRedirect>
      <React.StrictMode>
        <Store>
          <AppContent />
        </Store>
      </React.StrictMode>
    </HttpsRedirect>
  );
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
